import {Text, type TextProps} from '@mantine/core'
import {useEffect, useState} from 'react'

const name = 'devtime'

type Props = {
  animate: boolean
  onMainAnimationEnded?: () => void
  c?: TextProps['c']
}

export const Logo = ({animate, onMainAnimationEnded, c}: Props) => {
  const [partlyName, setPartlyName] = useState<string>('')
  const [animatingName, setAnimatingName] = useState<boolean>(animate)
  const [showUnderscore, setShowUnderscore] = useState<boolean>(true)

  useEffect(() => {
    if (!animate) return

    const timeoutIds: NodeJS.Timeout[] = []
    const initialDelayMs = 1000
    const delayMs = 150
    for (let i = 0; i < name.length; i++) {
      timeoutIds.push(setTimeout(() => setPartlyName(name.substring(0, i + 1)), initialDelayMs + delayMs * i))
    }

    // completed
    timeoutIds.push(
      setTimeout(
        () => {
          setAnimatingName(false)

          setTimeout(() => onMainAnimationEnded?.(), 1000)
        },
        initialDelayMs + delayMs * (name.length - 1),
      ),
    )

    return () => {
      for (const timeoutId of timeoutIds) {
        clearTimeout(timeoutId)
      }
    }
  }, [animate, onMainAnimationEnded])

  useEffect(() => {
    if (!animate) return
    if (animatingName) return

    const delayMs = 500

    let timeoutId: NodeJS.Timeout | undefined
    const blink = () => {
      setShowUnderscore((showUnderscore) => !showUnderscore)
      timeoutId = setTimeout(() => blink(), delayMs)
    }
    blink()

    return () => {
      if (timeoutId) clearTimeout(timeoutId)
    }
  }, [animate, animatingName])

  const textProps: TextProps = {
    size: 'xl',
    ff: 'monospace',
    c,
  }

  if (animate)
    return (
      <Text {...textProps}>
        {partlyName}
        <span style={{opacity: showUnderscore ? 1 : 0}}>_</span>
      </Text>
    )

  return <Text {...textProps}>{name}_</Text>
}
